import React from 'react';
import {GridCellParams} from '@mui/x-data-grid-pro';
import {Box} from '@mui/material';
import {AccountReviews_reviews} from '../../schema-types/AccountReviews';
import {ReviewStatusText} from '../HandoverStep/HandoverStep';

export function renderStatus(params: GridCellParams) {
  const review = params.row as AccountReviews_reviews;

  return (
    <Box display="flex" width="100%" justifyContent="center">
      <ReviewStatusText review={review} />
    </Box>
  );
}
